import { Breadcrumbs, CstmPagination } from "components/Common/Common";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { genericFormErrorMsg } from "utils/validation/validationHelpers";
import { Col, Container, Form, Row } from "react-bootstrap";

import styles from './profile.module.scss';
import { Formik } from "formik";
import { cloneDeep, debounce, isEmpty } from "lodash";
import { useCallback, useMemo, useState } from "react";
import { useCheckUsernameMutation, useGetAssociatedClientsQuery, useGetProfileQuery, useUpdateProfileMutation } from "store/services/auth";
import profileSchema from "./profile.schema";
import { EditIcon } from "Assets/icons";
import UpdateEmailPop from "components/Modals/UpdateEmailPop";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { dateFormat, errorMessageToast, successMessageToast } from "helpers/common";
import { useLazyGetFileUrlQuery } from "store/services/utility";
import AppInputFieldV2 from "components/Common/AppInputFIeldV2";
import FilePicker from "components/Common/FilePicker";
import TableLayoutV2 from "components/TableLayoutV2";
import { userProfileFilter } from 'store/slices/filter';
import { useDispatch, useSelector } from "react-redux";
import { usePersistentState } from "hooks/usePersistentState";
import { useGetMySchoolDataQuery } from "store/services/V2/profile";


const UserInformation = () => {
    const dispatch = useDispatch()

    const [showEmailModal, setShowEmailModal] = useState(false);
    const [usernameError, setUsernameError] = useState(null);
    const filter = useSelector(state => state?.filter?.userProfileFilter);
    const [currentEntry, setCurrentEntry] = useState(null);
    const [currentPage, setCurrentPage] = usePersistentState("userProfile:page", 1);
    const [pageSize, setPageSize] = useState(10);
    const { data: schoolDetails, isLoading: schoolDetailsLoading, isFetching: schoolDetailsFetching } = useGetMySchoolDataQuery();

    const { data: therapistDetails, isLoading: therapistDetailsLoading, isError: therapistDetailsError, isFetching: therapistDetailsFetching } = useGetProfileQuery();
    const [updateProfile, { isLoading: updateProfileLoading }] = useUpdateProfileMutation();
    const [checkUsername, { isLoading: checkUsernameLoading }] = useCheckUsernameMutation();
    const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();

    // const { data, isLoading, error } = useGetAssociatedClientsQuery({ page: currentPage, limit: pageSize, ...filter });

    // const associatedClients = data?.records || [];
    // const totalRecords = data?.totalRecords || 0;
    // const totalPages = Math.ceil(totalRecords / pageSize);


    const initialValues = useMemo(() => {

        return {
            profile_picture: therapistDetails?.profile_picture || "",
            firstname: therapistDetails?.firstname || "",
            lastname: therapistDetails?.lastname || "",
            email: therapistDetails?.email || "",
            phone: therapistDetails?.phone || "",
            username: therapistDetails?.username || "",
            profile_picture: therapistDetails?.therapist_detail?.profile_picture || "",
            status: therapistDetails?.status,
        }
    }, [therapistDetails]);

    const handleSubmit = async (payload) => {
        try {
            if (usernameError) {
                errorMessageToast(usernameError);
                return;
            };

            const values = cloneDeep(payload);
            const finalPayload = {
                phone: values?.phone || '',
                firstname: values?.firstname || '',
                lastname: values?.lastname || '',
                // profile_picture: values?.profile_picture || ''
            }


            const result = await updateProfile(finalPayload);
            if (result.error) return;

            successMessageToast(result?.data?.message);

        } catch (err) { console.error("Error updating profile", err); }
    };

    const handleUsernameChange = useCallback(debounce(async (value, setFieldError) => {
        try {
            if (value) {
                const response = await checkUsername({ username: value });
                if (response?.data?.data?.status == "false") {
                    setFieldError("username", "Username already exist")
                    setUsernameError("Username already exist");
                    return;
                };
                setFieldError("username", "")
                setUsernameError(null);
            };
        } catch (err) { console.error("Error checking username", err) };
    }, [500]));

    const handleAttachDocument = (name, value, prevValues = [], setFieldValue) => {
        try {
            let cloneValues = cloneDeep(prevValues);
            cloneValues.push({
                attachment_key: value,
                attachment_name: value,
            })
            setFieldValue(name, cloneValues);
        } catch (err) {
            console.error("Failed to attach document", err);
        }
    };

    const handleViewPdf = async (name) => {
        try {
            const url = await getFileUrl(name).unwrap();
            if (url) window.open(url, '_blank');

        } catch (err) { console.error("Error assigning therapist", err); }
    };

    const handleFilterChange = (key) => (value) => {
        dispatch(userProfileFilter({ ...filter, [key]: value }))
        setCurrentPage(1); // Reset to first page when filter changes
    };

    const handleGetRowColor = (item) => {
        if (item?.status == "pending") {
            return "rowYellow";
        }
        else if (item?.status == "inactive") {
            return "rowGray";
        }
    }

    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    const column = [
        // {
        //     head: <div onClick={() => dispatch(taskPlanFilter({ ...filter, sort: filter?.sort?.column == "is_favorite" ? { column: "id", direction: "ASC" } : { column: "is_favorite", direction: "desc" } }))}>{filter?.sort?.column == "is_favorite" ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div>,
        //     accessor: "is_favorite",
        //     isComponent: true,
        //     component: (item, ind) => (
        //         <h6 className="m-0 text-capitalize d-flex align-items-center gap-2"><div className="cursor-pointer" onClick={(e) => {
        //             e.stopPropagation();
        //             handleFavouriteReport(item?.id, item?.is_favorite ? 0 : 1)
        //         }}>{item?.is_favorite ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div></h6>
        //     ),
        // },


        {
            head: "FIRST NAME",
            accessor: "firstname",
            isComponent: true,
            sorter: true,
        },

        {
            head: "LAST NAME",
            accessor: "lastname",
            isComponent: true,
            sorter: true,
            width: "100%",

        },

        {
            head: "DOB",
            accessor: "dob",
            isComponent: true,
            sorter: false,
            width: "100%",
            component: (item, ind) => (
                <span>{dateFormat(item?.client_detail?.dob)}</span>
            )
        },

        {
            head: "GRADE",
            accessor: "grade",
            isComponent: true,
            sorter: false,
            width: "100%",
            component: (item, ind) => (
                <span>{item?.client_detail?.grade}</span>
            )
        },

        {
            head: "GENDER",
            accessor: "dob",
            isComponent: true,
            sorter: false,
            width: "100%",
            component: (item, ind) => (
                <span>{item?.client_detail?.gender}</span>
            )
        },
        // {
        //   head: "Action",
        //   accessor: "",
        //   isComponent: true,
        //   component: (item, index) => (
        //     item?.status != "discharged" &&
        //     <Dropdown
        //       onClick={(e) => e.stopPropagation()}
        //     >
        //       <Dropdown.Toggle
        //         variant="transparent"
        //         className="p-0 border-0 text-dark w-100"
        //         id="dropdown-basic"
        //       >
        //         <ThreeDotsMenuIcon />
        //       </Dropdown.Toggle>
        //       <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
        //         <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
        //           <h5 onClick={(e) => {

        //             e.stopPropagation();
        //             navigate(TASK_PLAN_EDIT.replace(":id", item.id));
        //           }} className="cursor-pointer proxima">
        //             Edit
        //           </h5>

        //         </ul>
        //       </Dropdown.Menu>
        //     </Dropdown>
        //   ),
        // },
    ];


    return (
        <>
            <div className="px-3 py-2">
                {/* <Breadcrumbs items={[{ label: "Profile", path: "/profile" }, { label: "User Information", path: "" }]} style={{ fontSize: "14px" }} /> */}

                <UpdateEmailPop
                    confirmation={showEmailModal}
                    setConfirmation={setShowEmailModal}
                />
                <section className={`${styles.addForm} position-relative col-lg-10 addForm`}>
                    <Container fluid={true}>
                        {(therapistDetailsLoading) ? <LoadingIndicator /> : <Row>
                            {(therapistDetailsFetching || getFileFetching) && <LoadingOverlay />}

                            <Col lg="12" className="my-2 px-0 ">
                                {therapistDetailsError ? (
                                    <ErrorComponent />
                                ) : (
                                    <Formik
                                        initialValues={initialValues}
                                        validationSchema={profileSchema}
                                        onSubmit={handleSubmit}
                                        enableReinitialize
                                    >
                                        {({
                                            handleSubmit,
                                            errors,
                                            submitCount,
                                            values,
                                            setFieldValue,
                                            setFieldError
                                        }) => (
                                            <Form onSubmit={handleSubmit}>
                                                <div
                                                >
                                                    <Breadcrumbs items={[{ label: "Profile", path: "/profile" }, { label: "User Information", path: "" }]} style={{ fontSize: "14px" }} />

                                                    <Col lg="12" className="my-2">
                                                        <div style={{ borderBottom: '0.75px solid #93278F', paddingBottom: "11px" }} className=' d-flex align-items-end justify-content-between'>
                                                            <h5 className='section-title-main fw-medium border-0 m-0 p-0'>User Information</h5>
                                                            <button className="discharge-screen">{updateProfileLoading ? <LoadingIndicator color="#fff" /> : 'Save Changes'}  </button>
                                                        </div>
                                                    </Col>

                                                    {/* <div className="px-0" style={{ marginTop: "24px" }}>
                                                        <h5 className="section-title">My Schools</h5>
                                                        {
                                                            schoolDetails?.length && schoolDetails?.map((item) => {
                                                                return (
                                                                    <Row className="mb-4">
                                                                        <Col xs="6" md='4'>
                                                                            <label className="discharge-screen-label">School Divisions</label><br />
                                                                            <p className="discharge-screen-sub-label mb-0" style={{ fontFamily: "Proxima Nova" }}>{item?.division_name}</p>
                                                                        </Col>
                                                                        <Col xs="6" md='4'>
                                                                            <label className="discharge-screen-label">Schools</label><br />
                                                                            {
                                                                                item?.schools?.map((list) => (
                                                                                    <p className="discharge-screen-sub-label mb-0" style={{ fontFamily: "Proxima Nova" }}>{list?.name}</p>
                                                                                ))
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                )
                                                            })
                                                        }

                                                    </div> */}

                                                    <div style={{ marginTop: "44px" }}>
                                                        <h5 className="section-title">PROFILE INFORMATION</h5>
                                                        <div className="d-flex flex-column gap-4">
                                                            <Row>
                                                                <Col md="6" className="d-flex gap-4">
                                                                    <div>
                                                                        <label className="discharge-screen-label">Last Name*</label>
                                                                        <AppInputFieldV2
                                                                            name="lastname"
                                                                            type="text"
                                                                            placeholder=""
                                                                            className={`readonly-box`}
                                                                        // disabled
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <label className="discharge-screen-label">First Name*</label>
                                                                        <AppInputFieldV2
                                                                            name="firstname"
                                                                            type="text"
                                                                            placeholder=""
                                                                            className={`readonly-box`}
                                                                        // disabled
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col md="4">
                                                                    <label className="discharge-screen-label">Email*</label>
                                                                    <AppInputFieldV2
                                                                        name="email"
                                                                        type="email"
                                                                        placeholder=""
                                                                        className={`readonly-box`}
                                                                        disabled
                                                                    />
                                                                </Col>
                                                                <Col md="2">
                                                                    <label className="discharge-screen-label">Phone Number*</label>
                                                                    <AppInputFieldV2
                                                                        name="phone"
                                                                        type="text"
                                                                        placeholder=""
                                                                        className={`readonly-box`}
                                                                    // disabled
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </div>

                                                    {/* <div style={{ marginTop: "44px" }}>
                                                        <h5 className="section-title">ASSOCIATED CLIENTS</h5>
                                                        <div className="table-outer mt-3">
                                                            <TableLayoutV2
                                                                data={associatedClients}
                                                                column={column}
                                                                filter={filter}
                                                                // url={TASK_PLAN_TEMPLATES_EDIT.replace("/:id", "")}
                                                                handleSort={handleFilterChange("sort")}
                                                                handleGetRowColor={handleGetRowColor} />
                                                            <CstmPagination
                                                                totalPages={totalPages}
                                                                className={'paginationV2'}
                                                                activePage={currentPage}
                                                                handlePageChange={handlePageChange}
                                                            />
                                                        </div>
                                                    </div> */}


                                                    {/* <div style={{ marginTop: "44px" }}>
                                                        <h5 className="section-title">PROFILE IMAGE</h5>
                                                        <Row className="pe-md-4">
                                                            <Col lg='4'>
                                                                <p style={{ fontStyle: "italic", fontSize: "14px", color: "rgb(7, 30, 62);" }}>Profile Image File</p>
                                                            </Col>
                                                            <Col lg='4'>
                                                                <FilePicker
                                                                    value={values?.profile_picture}
                                                                    onChange={(fileUrl) => setFieldValue("profile_picture", fileUrl)}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </div> */}
                                                </div>
                                                {(!isEmpty(errors) && submitCount > 0) && (
                                                    <Row className="mt-4">
                                                        <Col lg="12">
                                                            <span className="error">{genericFormErrorMsg}</span>
                                                        </Col>
                                                    </Row>
                                                )}
                                                {/* <Row className="mt-4">
                                                <Col className="my-2" lg="12">
                                                    <div
                                                        className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                                                        style={{ borderTop: "1px solid #41a2a84d" }}
                                                    >
                                                        <LoadingButton
                                                            type="submit"
                                                            className="d-flex align-items-center justify-content-center commonBtn"
                                                            isLoading={updateProfileLoading}
                                                        >
                                                            Save
                                                        </LoadingButton>
                                                    </div>
                                                </Col>
                                            </Row> */}
                                            </Form>
                                        )}
                                    </Formik>
                                )}
                            </Col>
                        </Row>}
                    </Container>
                </section>
            </div>
        </>
    );
};

export default UserInformation;